import { APP_DOMANIN } from '../confs/costants'

import { isEmpty } from './stringValidation'


const DEFAULT_COOKIE_NAME = 'jwt'
const DEFAULT_COOKIE_PATH = '/'

export function createToken (heders: Headers) {
    let jwt_value = heders.get( 'x-token' )
    let jwt_expire = heders.get( 'x-token-exp' )

    const cookie : any = {
        name: DEFAULT_COOKIE_NAME,
        domain: `.${APP_DOMANIN}`,
        path: DEFAULT_COOKIE_PATH,
        expires: jwt_expire,
        value: jwt_value
    }

    if (APP_DOMANIN.includes('6sicuro.net'))  {
        cookie.domain = "6sicuro.net"
        cookie.hostOnly = true
        cookie.SameSite = "no_restriction"
    }

    if ( !isEmpty(jwt_value) && !isEmpty(jwt_expire) ) {
        writeCookie (cookie)
    }
    else {
        deleteToken (cookie)
    }
}


export function deleteToken (cookieData?: any) {
    deleteCookie (cookieData)
}

export function getToken () {
    return getCookie()
}


/// --- utils private

/**
 * Ritorna il valore di un cookie in base al nome
 * @param name il nome del cookie
 * @returns il valore sse esiste, undefined altrimenti
 */
function getCookie (name?: string) : string | undefined  {
    if (!name) {
        name = DEFAULT_COOKIE_NAME
    }

    const match = document.cookie.match (new RegExp('(^| )' + name + '=([^;]+)'))
    return (match) ? match[2] : undefined
}

/**
 * scrive un cookie
 * @param cookieData  i dati da associare al cookie
 */
function writeCookie (cookieData: any) {
    if (!cookieData?.domain) {
        cookieData.domain = APP_DOMANIN
    }

    if (!cookieData?.path) {
        cookieData.path = '/';
    }

    if (!cookieData?.expires) {
        const dt = new Date();
        dt.setTime(dt.getTime() + (60 * 60 * 24 * 30));
        cookieData.expires = `${getUtcStringTimezone(dt)}`;
    }
    else if (cookieData.expires instanceof Date) {
        cookieData.expires = `${getUtcStringTimezone(cookieData.expires)}`;
    }
    else {
        const dt = new Date(cookieData.expires);
        cookieData.expires = `${getUtcStringTimezone(dt)}`;
    }

    if (!cookieData?.SameSite) {
        cookieData.SameSite = "Lax";
    }

    const hostOnly = (cookieData.hostOnly !== undefined) ? `; hostOnly= ${cookieData.hostOnly}` : "";

    document.cookie = `${cookieData.name}=${cookieData.value}; domain=${cookieData.domain}; path=${cookieData.path}; expires=${cookieData.expires}; samesite=${cookieData.SameSite}${hostOnly}`;
}

function getUtcStringTimezone (date: Date) : String {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000
    date.setTime (
        (timeOffsetInMS >= 0)
            ? date.getTime() + timeOffsetInMS
            : date.getTime() - timeOffsetInMS
    )

    return date.toUTCString()
}

/**
 * Cancella un cookie
 */
function deleteCookie (cookieData? : any) {
    let cName: string = DEFAULT_COOKIE_NAME, domain: string = APP_DOMANIN, path: string = DEFAULT_COOKIE_PATH;

    if (cookieData) {
        cName = cookieData.name
        domain = cookieData.domain
        path = cookieData.path
    }
    document.cookie = `${cName}=; domain=${domain}; path=${path}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}